// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

// export default new Vuex.Store({
//   state: {
//     userId: null,
//     userType: null,
//   },
//   getters: {
//     getUserId: state => {
//       return state.userId
//     },
//     getUserType: state => {
//       return state.userType
//     }
//   },
//   mutations: {
//     SET_USERID(state, payload) {
//         state.userId = payload
//     },
//     SET_USERTYPE(state, payload) {
//         state.userType = payload
//     },
//   },
//   actions: {
//     setUserId: ({ commit, state }, payload) => {
//         const data = data;
//         commit('SET_USERID', payload)
//     },
//     setUserType: ({ commit, state }, payload) => {
//         commit('SET_USERTYPE', payload)
//     }
//   }
// })

import Vue from 'vue'
import Vuex from 'vuex'
import UserModule from './user_module'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const modules = {
    user: UserModule,
}

export default new Vuex.Store({
    modules,
    plugins: [
        createPersistedState({
            key: 'session_data',
            paths: ['user']
        })
    ]
})